const publicPath = process.env.PUBLIC_PATH

export { publicPath }
